<template>
  <!--  서브페이지  -->
  <div id="sub_area">
    <div v-if="!MainHide">
      <!--비주얼 영역-->
      <div class="sub_visual">
        <div class="tit_area">
          <h2 class="tit">{{ title }}</h2>
        </div>
        <img :src="require('./../../assets/img/sub/SUB_01.png')" alt="BG" />
      </div>

      <div class="navigation_area">
        <div class="navigation">
          <router-link to="/" class="i_home">
            <span>HOME</span>
          </router-link>

          <div
            class="item"
            :class="{ on: mainMenuShow }"
            @mouseover="mainMenuShow = true"
            @mouseleave="mainMenuShow = false"
          >
            <a>{{ title }}</a>
            <div>
              <router-link
                active-class="on"
                tag="a"
                to="/Company/CEO"
                @click.native="mainMenuShow = false"
              >CEO</router-link>
              <router-link
                active-class="on"
                tag="a"
                to="/Company/Principle"
                @click.native="mainMenuShow = false"
              >회사소개</router-link>
              <router-link
                active-class="on"
                tag="a"
                to="/Company/History"
                @click.native="mainMenuShow = false"
              >연혁</router-link>
              <router-link
                active-class="on"
                tag="a"
                to="/Company/Network"
                @click.native="mainMenuShow = false"
              >네트워크</router-link>
              <router-link
                active-class="on"
                tag="a"
                to="/Company/CI"
                @click.native="mainMenuShow = false"
              >CI</router-link>
              <router-link
                active-class="on"
                tag="a"
                to="/Company/Ethics"
                @click.native="mainMenuShow = false"
              >윤리경영</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    mainMenuShow: false,
    message: "CompanyMain.vue",
    MainHide: false,
    title: ""
  }),
  methods: {
    titleChange(urlPath) {
      switch (urlPath) {
        case "/Company/CEO":
          {
            this.title = "CEO";
            this.MainHide = false;
          }
          break;
        case "/Company/Principle":
          {
            this.title = "회사소개";
            this.MainHide = true;
          }
          break;
        case "/Company/History":
          {
            this.title = "연혁";
            this.MainHide = false;
          }
          break;
        case "/Company/Network":
          {
            this.title = "네트워크";
            this.MainHide = false;
          }
          break;
        case "/Company/CI":
          {
            this.title = "CI";
            this.MainHide = false;
          }
          break;
        case "/Company/Ethics":
          {
            this.title = "윤리경영";
            this.MainHide = false;
          }
          break;
      }
    }
  },
  computed: {},
  watch: {
    $route(to, from) {
      this.titleChange(to.path);
    }
  },
  destroyed() {},
  created() {
    console.log("created - " + this.message);
    this.titleChange(this.$route.path);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/CompanyMain.vue